/** * * Asynchronously loads the component for
Terms And Conditions
* */ import { lazyLoad } from "utils/loadable";
export const TermsAndConditions = lazyLoad(
  () => import("./index"),
  (module) => module.TermsAndConditions
);
